import {
  AuthHeader,
  ForgotPasswordForm,
  SuccessMessage,
} from '@/features/auth/components';
import { useCustomAuthenticationForgotPassword } from '@/features/auth/hooks/use-custom-authentication-forgot-password.hook';
import { LoadingSpinner } from '@/shared/ui';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';

export const Route = createFileRoute('/_auth/forgot')({
  component: ForgotPasswordPage,
  pendingComponent: LoadingSpinner,
});

function ForgotPasswordPage() {
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const { mutateAsync: forgotPassword, isPending: isLoading } =
    useCustomAuthenticationForgotPassword();

  const handleSubmit = async (email: string) => {
    setError('');
    try {
      await forgotPassword(email);
      setSuccess(true);
    } catch (e) {
      setError(
        e instanceof Error ? e.message : 'Erro ao enviar e-mail de recuperação',
      );
    }
  };

  if (success) {
    return (
      <SuccessMessage
        title='E-mail enviado!'
        message='Se o endereço estiver cadastrado, você receberá um e-mail com um botão para cadastrar sua nova senha. Verifique também a caixa de spam.'
        buttonText='Voltar ao login'
        buttonLink='/login'
      />
    );
  }

  return (
    <>
      <AuthHeader
        title='Esqueceu sua senha?'
        subtitle='Informe seu e-mail. Enviaremos um link com um botão para cadastrar uma nova senha.'
      />

      <ForgotPasswordForm
        onSubmit={handleSubmit}
        loading={isLoading}
        error={error}
      />
    </>
  );
}
